<div><i (click)="toggleFullScreen()" class="pointer json-editor-maximize-icon g-icon g-icon-maximize"></i></div>